import React, {FC} from 'react'

import cn from 'classnames/bind'

import PricingCard from 'components/blocks/PricingCard'
import {Container, Row, Col} from 'components/elements/grid'
import {IPriceCardItem} from 'components/templates/TemplatePricing/TemplatePricing'

import s from './PricingSection.module.scss'
const cx = cn.bind(s)

interface IPricingSectionProps {
	pricingItems: IPriceCardItem[]
	className?: string
}

const PricingSection: FC<IPricingSectionProps> = ({pricingItems, className}) => {
	return (
		<section className={cx('pricing-section', className)}>
			<Container>
				<Row>
					{pricingItems.map((item) => (
						<Col
							key={item.id}
							md={{offset: 2, span: 8}}
							lg={{offset: 0, span: 4}}
							className={cx('col-card')}>
							<PricingCard
								color={item.color}
								title={item.title}
								currency={item.currency}
								slug={item.slug}
								price={item.price}
								priceTitle={item.priceTitle}
								label={item.label}
								benefits={item.benefits}
								href={item.href}
							/>
						</Col>
					))}
				</Row>
			</Container>
		</section>
	)
}

PricingSection.displayName = 'PricingSection'

export default PricingSection
